import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Fraccion1Service } from 'src/services/Articulo8/Fraccion1.service';
import { GeneralService } from 'src/services/general.service';
import { SweetAlertService } from 'src/services/sweet-alert.service';

@Component({
  selector: 'app-ver-cronica',
  templateUrl: './ver-cronica.component.html',
  styleUrls: ['./ver-cronica.component.scss']
})
export class VerCronicaComponent {
  idNoticia: any;
  boton: any;
  cronicas: any;
  noticia: any;
  id: any
  estatus: any
  constructor(private activerouter: ActivatedRoute, private router: Router, private api: Fraccion1Service, private general: GeneralService, private alerts: SweetAlertService) { }

  ngOnInit(): void {

    if (localStorage.getItem('token')) {
      this.boton = 1;
    }

    this.id = this.activerouter.snapshot.paramMap.get('id');
    console.log(this.idNoticia);

    this.general.listaCronista().subscribe(res => {
      this.cronicas = res.body;
      console.log(this.cronicas);

    })

    this.api.cronistaid(this.id).subscribe(res => {
      this.noticia = res.body;
      console.log(this.noticia);

    })

  }

  subirNoticia() {
    localStorage.setItem('idNoticia', this.id);
    this.router.navigate(['admin/subir-noticia']);
  }

  eliminar() {
    this.id = this.activerouter.snapshot.paramMap.get('id');
    this.general.eliminarCronica(this.id).subscribe((res: any) => {
      this.estatus = res.body;


      this.alerts.alertaConfirmacion('Eliminar', '¿Desea eliminar esta noticia?').then((res: any) => {

        if (res.isConfirmed) {
          this.alerts.alertaRealizado().then((res: any) => {
            this.router.navigate(['admin/cronista']);
          })

        }




      })


    })
  }
}
